
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
const Layout = _Layout;
const meta = {
  "id": "othersolutions",
  "title": "Solutions Ideas",
  "sidebar_label": "Other Solutions"
};
const slug = 'othersolutions';
const tableOfContents = [];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Second hand goods marketplace, `}</li>
      <li parentName="ul">{`Electronics marketplace (rental, buy, sell, swap etc)`}</li>
      <li parentName="ul">{`Fashion marketplace & Luxury items marketplace (rental, buy, sell, swap etc)`}</li>
      <li parentName="ul">{`Grocery marketplace`}</li>
      <li parentName="ul">{`Recycle marketplace`}</li>
      <li parentName="ul">{`Property marketplace (rental, buy, etc)`}</li>
      <li parentName="ul">{`Goods Donation marketplace`}</li>
      <li parentName="ul">{`Money Donation marketplace (Crowd donation)`}</li>
      <li parentName="ul">{`Social feedback / Crowdsourcing ideas`}</li>
      <li parentName="ul">{`Cooperative marketplaces`}</li>
      <li parentName="ul">{`Employee/Society/Community based marketplaces`}</li>
      <li parentName="ul">{`Farmers Marketplace (Connecting farmers with direct buyers of agriculture products)`}</li>
    </ul>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
